module.exports = __webpack_public_path__ + "static/img/404.9ed13bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error/404.svg
// module id = 4BOe
// module chunks = 14